export function formatApprovalStatus(status: string): string {
  switch (status) {
    case 'pending_approval':
      return 'Pending approval';
    case 'declined':
      return 'Declined';
    case 'approved':
      return 'Approved';
    default:
      return status.replace(/_/g, ' ');
  }
}

export function approvalOverlayBadgeClass(status: string): string {
  switch (status) {
    case 'pending_approval':
      return 'bg-warning/90 text-ink';
    case 'declined':
      return 'bg-danger/90 text-white';
    case 'approved':
      return 'bg-success/90 text-white';
    default:
      return 'bg-black/65 text-white';
  }
}

export function approvalGuestBadgeClass(status: string): string {
  const base = 'shrink-0 rounded-pill px-2 py-0.5 text-[0.625rem] font-semibold uppercase tracking-[0.08em]';
  switch (status) {
    case 'pending_approval':
      return `${base} bg-warning/15 text-warning`;
    case 'declined':
      return `${base} bg-danger/10 text-danger`;
    case 'approved':
      return `${base} bg-success/15 text-success`;
    default:
      return `${base} bg-sunken text-ink-secondary`;
  }
}
